RivalIQ.apps.Admin.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const widgets = [{
        widgetId: RivalIQ.enums.widgetTypes.INVOICES
    }];

    function restrictToAdmin() {
        if (!RivalIQ.state.account.isAdmin()) {
            return _.partial(_.identity, '/overview');
        }
    }

    const Panel = RivalIQ.apps.Dashboard.views.DetailsLayout.extend({
        template: '#dashboardWidgetAlternateDetailLayoutTemplate',
        showLeftToolbarActions: _.noop,
        showToolbarActions: function () {
            const me = this;

            me.actions.show(new RivalIQ.views.Link({
                className: 'btn btn-default',
                linkName: 'Create Invoice',
                action: function () {
                    RivalIQ.execute('show:modal', new App.widgets.InvoiceCreateEdit({
                        model: new RivalIQ.apps.Admin.models.Invoice({
                            account_id: me.getProp('accountId')
                        })
                    }));
                }
            }));
        }
    });

    curations.Invoices = Dashboard.models.Curation.extend({
        title: 'Invoices',
        beforeFilters: [
            restrictToAdmin
        ],
        widgetDefinitions: widgets,
        companySets: false,
        timePeriod: false,
        page: RivalIQ.configuration.menus.getConfiguration().ADMIN,
        widgetsView: RivalIQ.apps.Dashboard.views.Widgets.extend({
            panelView: Panel
        })
    });
});
